<template>
  <section class="home-hero-wrap">
    <NetworkBackground />
    <section class="hero" :style="heroStyle">
      <div class="container">
        <div class="hero-badge reveal">
          <PulseIndicator />
          新基建领域首个行业生态平台
        </div>
        <h1 class="hero-title reveal">生态，<span class="gradient-text">让生意更简单</span>。</h1>
        <h2 class="hero-subtitle reveal">易隆创是新基建领域首个产业生态共同体。</h2>
        <p class="hero-copy reveal">
          <span style="color:var(--amber)">你有关系，我有资源</span>，我们一起把项目做好，利润你拿大头。
        </p>
        <div class="hero-actions reveal">
          <AppButton variant="primary" to="/register?eco=partner" arrow>
            免费注册合伙人
          </AppButton>
          <AppButton variant="outline" @click="scrollToEcosystems">
            了解四大生态
          </AppButton>
        </div>
        <div class="stats reveal">
          <StatCard v-for="s in stats" :key="s[1]" :value="s[0]" :label="s[1]" />
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import AppButton from '@/components/buttons/AppButton.vue';
import PulseIndicator from '@/components/display/PulseIndicator.vue';
import StatCard from '@/components/cards/StatCard.vue';
import NetworkBackground from '@/components/display/NetworkBackground.vue';

export default {
  name: 'HomeHero',
  components: { AppButton, PulseIndicator, StatCard, NetworkBackground },
  props: {
    image: { type: String, default: '' }
  },
  data() {
    return {
      stats: [
        ['350+', '入驻合伙人'],
        ['1200+', '供应商生态'],
        ['13980', '服务团队'],
        ['356+', '解决方案生态']
      ]
    };
  },
  computed: {
    heroStyle() {
      return { backgroundImage: 'url(' + this.image + ')' };
    }
  },
  methods: {
    scrollToEcosystems() {
      const el = document.getElementById('ecosystems');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }
};
</script>

<style lang="less" scoped>
.home-hero-wrap {
  position: relative;
}

.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(5, 11, 24, 0.92), rgba(5, 11, 24, 0.54) 60%, #050b18);
  }

  .container {
    position: relative;
    z-index: 2;
    padding-top: 92px;
  }
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 7px 14px;
  border-radius: 999px;
  background: rgba(66, 217, 255, 0.1);
  border: 1px solid rgba(66, 217, 255, 0.28);
  color: #94ecff;
  font-size: 13px;
}

.hero-title {
  font-size: 72px;
  line-height: 1.08;
  margin-top: 28px;
  letter-spacing: -0.04em;
  font-weight: bold;
}

.hero-subtitle {
  font-size: 30px;
  font-weight: 600;
  line-height: 1.3;
  margin-top: 18px;
  color: #dde6f7;
  letter-spacing: -0.01em;
}

.hero-copy {
  font-size: 22px;
  color: #c3cee4;
  max-width: 760px;
  margin-top: 24px;
}

.hero-actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 34px;
}

.stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  max-width: 790px;
  gap: 24px;
  margin-top: 78px;
}

@media (max-width: 1100px) {
  .hero-title { font-size: 58px; }
  .hero-subtitle { font-size: 26px; }
}

@media (max-width: 760px) {
  .hero-title { font-size: 46px; }
  .hero-subtitle { font-size: 22px; }
  .hero-copy { font-size: 17px; }
  .stats {
    grid-template-columns: repeat(2, 1fr);
    margin-top: 48px;
  }
}
</style>
